import React from 'react';
import { CheckIcon } from '../../components/public/icons';
import { mainSiteUrl } from '../../constants/discovery';
import DiscoveryJoinForm from './DiscoveryJoinForm';
import DiscoveryMap from './DiscoveryMap';

const MILESTONES = [
  { n: '01', title: 'We build the community', status: 'Happening now', body: 'We’re bringing independent beauty professionals together and welcoming the founding members who will shape what comes next.' },
  { n: '02', title: 'We open the marketplace', status: 'Coming next', body: 'Then we’ll open Discovery: a local marketplace and map where clients can find nearby talent, explore their work, and book.' },
];
const Wordmark = ({ size = 'md' }) => (
  <span className={`discovery-wordmark discovery-wordmark--${size}`}>
    <span className="discovery-wordmark__haastia">haastia</span>
    <span className="discovery-hand discovery-wordmark__discovery">discovery</span>
  </span>
);

const CheckList = ({ items }) => (
  <ul className="discovery-checklist">
    {items.map((item) => (
      <li key={item}><CheckIcon size={19} />{item}</li>
    ))}
  </ul>
);

const DiscoveryPage = () => (
  <>
    <main className="discovery">
      <section className="discovery-hero" aria-labelledby="discovery-title">
        <DiscoveryMap />
        <header className="discovery-header">
          <a href={mainSiteUrl()} className="discovery-header__home" aria-label="Haastia home">
            <Wordmark size="lg" />
          </a>
          <nav className="discovery-header__nav" aria-label="Discovery">
            <a href="#vision">Our vision</a>
            <a href="#roadmap">The roadmap</a>
            <a href="#join" className="discovery-btn discovery-btn--primary discovery-btn--small">Join the community</a>
          </nav>
        </header>
        <div className="discovery-hero__content">
          <div className="discovery-hero__copy">
            <span className="discovery-pill"><span className="discovery-pill__dot" />Coming soon · Free to join</span>
            <h1 id="discovery-title">Great work deserves to be <span className="discovery-accent">discovered.</span></h1>
            <p className="discovery-hero__lead">
              We&rsquo;re bringing independent beauty professionals together in one community. Soon, clients will be able to discover local talent, explore their work, and book their next appointment.
            </p>
            <div className="discovery-hero__actions">
              <a href="#join" className="discovery-btn discovery-btn--primary discovery-btn--large">
                Join the founding community <span aria-hidden="true">&rarr;</span>
              </a>
              <span className="discovery-hand discovery-hero__note">Be here from day one.</span>
            </div>
          </div>
        </div>
        <p className="discovery-hero__caption">Illustrative map · Discovery is coming soon</p>
      </section>
      <div className="discovery-rule" aria-hidden="true" />

      <section id="vision" className="discovery-section discovery-who" aria-labelledby="discovery-who-title">
        <div className="discovery-who__inner">
          <div>
            <span className="eyebrow">Built for independent beauty</span>
            <h2 id="discovery-who-title">Your talent deserves more than word of mouth.</h2>
          </div>
          <div>
            <p className="discovery-who__lead">
              From hairstylists and braiders to nail artists, lash techs, makeup artists, and home-based beauty pros, we&rsquo;re building a place for independent talent to connect, be seen, and grow together.
            </p>
            <p className="discovery-hand discovery-who__note">Independent doesn&rsquo;t mean you have to grow alone.</p>
          </div>
        </div>
      </section>

      <section id="roadmap" className="discovery-section discovery-roadmap" aria-labelledby="discovery-roadmap-title">
        <div className="discovery-section__inner">
          <div className="discovery-section__heading">
            <span className="eyebrow">What comes next</span>
            <h2 id="discovery-roadmap-title">The road to Discovery</h2>
            <p>First, we build the community. Then, we open the marketplace and map.</p>
          </div>
          <div className="discovery-roadmap__journey" aria-hidden="true">
            <div className="discovery-roadmap__community-scene">
              <span className="discovery-roadmap__avatar discovery-roadmap__avatar--one" />
              <span className="discovery-roadmap__avatar discovery-roadmap__avatar--two" />
              <span className="discovery-roadmap__avatar discovery-roadmap__avatar--three" />
              <span className="discovery-roadmap__people-label">community</span>
            </div>
            <div className="discovery-roadmap__path">
              <span className="discovery-roadmap__traveler" />
            </div>
            <div className="discovery-roadmap__map-scene">
              <span className="discovery-roadmap__map-grid" />
              <span className="discovery-roadmap__pin discovery-roadmap__pin--one" />
              <span className="discovery-roadmap__pin discovery-roadmap__pin--two" />
              <span className="discovery-roadmap__pin discovery-roadmap__pin--three" />
              <span className="discovery-roadmap__map-label">Discovery map</span>
            </div>
          </div>
          <ol className="discovery-roadmap__list">
            {MILESTONES.map((milestone, index) => (
              <li key={milestone.n} className={index === 0 ? 'discovery-roadmap__current' : undefined} aria-current={index === 0 ? 'step' : undefined}>
                <span className="discovery-roadmap__number" aria-hidden="true">{milestone.n}</span>
                <span className="discovery-roadmap__status">{milestone.status}</span>
                <h3>{milestone.title}</h3>
                <p>{milestone.body}</p>
              </li>
            ))}
          </ol>
        </div>
      </section>

      <section id="join" className="discovery-join" aria-labelledby="discovery-join-title">
        <div className="discovery-join__panel">
          <div className="discovery-join__copy">
            <span className="eyebrow">The founding community</span>
            <h2 id="discovery-join-title">Be here from the <span className="discovery-accent">beginning.</span></h2>
            <p className="discovery-join__lead">
              Join our founding community of independent beauty professionals. Get updates as Discovery takes shape, hear about early access, and help shape what&rsquo;s next.
            </p>
            <CheckList items={['Free to join', 'Early updates and launch access', 'Opportunities to help shape Discovery']} />
            <p className="discovery-join__note">
              <strong>No booking account needed.</strong>{' '}
              <span>Use the booking tools that work for you.</span>
            </p>
          </div>
          <DiscoveryJoinForm />
        </div>
      </section>

      <section className="discovery-booking-site" aria-labelledby="discovery-booking-site-title">
        <div className="discovery-booking-site__inner">
          <div>
            <span className="eyebrow">More ways to grow</span>
            <h2 id="discovery-booking-site-title">Want your own booking site?</h2>
            <p>Create a beautiful home for your services, bookings, and clients with Haastia.</p>
          </div>
          <a href={mainSiteUrl()} className="discovery-btn discovery-btn--outline">Explore Haastia</a>
        </div>
      </section>
    </main>

    <footer className="discovery-footer">
      <div className="discovery-footer__inner">
        <div className="discovery-footer__brand">
          <Wordmark size="sm" />
          <span>A place for independent professionals.</span>
        </div>
        <nav className="discovery-footer__links" aria-label="Footer">
          <a href={mainSiteUrl()}>haastia.com</a>
          <a href={mainSiteUrl('/privacy')}>Privacy</a>
          <a href="mailto:info@haastia.com">Say hello</a>
        </nav>
      </div>
    </footer>
  </>
);

export default DiscoveryPage;
